module.exports = __webpack_public_path__ + "img/People Manager.f281b543.svg";